import { server } from '../core/server/axios';
import { BACKEND_URL } from '@/core/config';

/**
 * Предоплата брони картой (эквайринг) — только для брони с сайта.
 *
 * Клиент платит после подтверждения казначея; до оплаты бронь не доходит до кассира.
 * При закрытии операции процесс сам снимает сумму предоплаты с кассы и проводит изъятие
 * в ОФД — фронт деньги не двигает, только показывает и печатает документы.
 */

/** Ответ /Acquiring/requests/{requestId}/payment */
export interface AcquiringRequestPaymentState {
    requestId: number;
    /** Статус заявки (ApplicationStatus) */
    requestStatus: number;
    /** Бронь ещё действует */
    isBookingActive: boolean;
    /** Казначей подтвердил бронь */
    isBookingConfirmed: boolean;
    /** Предоплата внесена */
    isPaid: boolean;
    amount: number | null;
    order: string | null;
    paidAt: string | null;
}

export class AcquiringController {
    /** Предоплата по заявке. Незавершённый заказ сервер попутно сверяет с банком. */
    async getRequestPayment(requestId: number | string): Promise<AcquiringRequestPaymentState> {
        return await server.get(`/Acquiring/requests/${requestId}/payment`, {
            baseURL: BACKEND_URL,
        });
    }
}
